/* eslint-disable array-callback-return */
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { showToast } from 'modules/layout/layout.actions';
// import CancelIcon from '@mui/icons-material/Cancel';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Rating from '@mui/material/Rating';
import Spinner from 'modules/common/spinner.component';
import { formatDateForInput } from 'utilities/common';

import { InfoOutlined, PauseCircle } from '@mui/icons-material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import { Link } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { AUTHORIZATION_FILE_STATUS_IDS } from 'modules/enumerations/enumerationIds';

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '3px',
    marginTop: '-6px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 330,
    marginBottom: 0
  },
  initiatedStatusBox: {
    border: '1px solid #67a783',
    borderRadius: '5px',
    padding: '5px',
    textAlign: 'center',
    minHeight: 30,
    background: '#67a783'
  },
  notInitiatedStatusBox: {
    border: '1px solid #fd6120',
    borderRadius: '5px',
    padding: '5px',
    textAlign: 'center',
    minHeight: 30,
    background: '#fd6120'
  },
  expensesStatusBox: {
    border: '1px solid #868686',
    borderRadius: '5px',
    padding: '5px',
    textAlign: 'center',
    minHeight: 30,
    background: '#868686'
  }
}));

/*
      - Required Props:
       * tabs - a list of tabs to be included in the card
       * summaries - a list of objects detailing the specific textfield requirements for the editing feature as well as the necessary values to display
       * numColumns - number of xl device columns
      - Optional Props:
       * updateFields (typically an API PUT call followed by GET call to refresh the data, returns boolean)

      - Required Label Fields: accessorKey, header, type, options (only required for dropdown type)
      - Optional Label Fields: required (defaults to false), size, enableColumnOrdering, enableEditing, enableSorting, hideInTable (if column should be displayed in the CRUD table or not)

      - Label Types: text, notes, number, date, dropdown, dropdownv2

      Tabs are displayed in the order they appear in the list. If there is only one item in the list, then it will be displayed as a 'header' (not clickable, no other visible tabs) and all items in the summaries list will be displayed and editable by default. If within the summaries list
      there is an item with a 'tab' option of a different value than the 'order' in the single item within the tabs list. (Example - there is an item in the summaries list with a 'tab' value of 3. There is only one item in the tabs list. That item will still be displayed within the card.)

      const tabs = [
          { accessorKey: 'nameOfTabMatchingInSummaries', header: 'displayTitleOfTab', order: 1, iconPath: ['fas', 'user-friends'] },
      ];

      The editable card is largely based off of the CRUD table functionality. An example of a label input is:
      const summaries = [
          { header: 'Text Example', type: 'text', required: true, size: 72 },
          { header: 'Dropdown Example', type: 'dropdown', options: ['Yes', 'No'], required: true, size: 68 },
          { header: 'Dropdown Version 2 Example', type: 'dropdown-v2', options: arrayOfOptions, defaultVal: 0, required: true, Cell: ({cell}) => cell.fieldValues.original.dropdownV2Example != null && <p>{dropdownV2Exampoe.find(o => o.id === cell.fieldValues.dropdownV2Example).title}</p>} ,
          { header: 'Checkbox Example', type: 'checkbox', defaultVal: false, required: true, Cell: ({cell}) => <Checkbox name="checkboxExample" label="Active" checked=(cell.fieldValues.original.checkboxExample} disabled={false} },
          { header: 'Date Example', type: 'date', required: true, size: 72 },
          { header: 'Notes Example', type: 'notes', required: true},
      ]

      Included in the summaries array, you need a VALUE that contains the proper value you want displayed. An example is that fields = authorizationInformation. Values will then be gathered by the accessor key in the summaries array:

            We want to display the values for an authorization's ID and Client:
            const summaries = [
              { header: 'File #', value: this.props.authorizationInformation.mtAuthorizationId, type: 'text', required: true, disabled: true },
              { header: 'Client', value: this.props.authorizationInformation.client.description, type: 'text', required: true, disabled: true },
            ]

      The updateFields props is a FUNCTION for updating the fields via the editing modal. Here is an example of how to write an updateFields function:

      const updateAuthorizationInformation = async (authorizationInformation, values) => {
        const id = authorizationInformation.mtAuthorizationId;
        values.mtAuthorizationId = id;
        values.clientId = authorizationInformation.clients.clientId;
        const resp = await props.updateAuthorizationInformation(values);
        if (resp.type === UPDATE_AUTHORIZATION_INFORMATION_FAILURE) {
          return false;
        } else {
        const getResp = await props.getAuthorizationInformation(authorizationInformation.clients.clientId);
        if (getResp.type === GET_AUTHORIZATION_INFORMATION_FAILURE) {
          return false;
        } else {
          return true;
        }
      }
    };

  */

const MULTIPLE_STATUS_LABEL = 'Multiple';

const DETAIL_CELL_PADDING_X = 14;
const DETAIL_CELL_INDENT_X = DETAIL_CELL_PADDING_X + 16;

const detailCellSx = {
  padding: `7px ${DETAIL_CELL_PADDING_X}px`,
  fontSize: '0.8125rem',
  color: '#43423a',
  whiteSpace: 'nowrap'
};

const detailHeaderSx = {
  ...detailCellSx,
  fontWeight: 550,
  fontSize: '0.9rem',
  color: COLOR_PRIMARY.contrastText,
  backgroundColor: COLOR_PRIMARY.main,
  borderBottom: 'none'
};

/*
  HHG and temp living report a status per segment / per stay rather than one on the service itself.
  A single entry displays like any other service, multiple entries collapse to 'Multiple'.
*/
export const resolveGroupedServiceStatus = (entries, serviceStatus) => {
  if (!entries || entries.length === 0) return serviceStatus;
  if (entries.length === 1) return entries[0].statusName;
  return MULTIPLE_STATUS_LABEL;
};

/* Flattens the temp living stays into one row each. */
export const buildTempLivingDetailRows = tempLivingStatuses =>
  (tempLivingStatuses || []).map(stay => ({ name: stay.serviceName, status: stay.statusName }));

/* Flattens each HHG segment into a row, followed by an indented row per estimate on that segment. */
export const buildHhgDetailRows = hhgSegments =>
  (hhgSegments || []).flatMap(segment => {
    const rows = [{ name: segment.serviceName, status: segment.statusName }];

    if (!segment.estimates || segment.estimates.length === 0) {
      rows.push({ name: 'No estimates', isIndented: true, isPlaceholder: true });
      return rows;
    }

    segment.estimates.forEach(estimate => {
      rows.push({ name: `Estimate: ${estimate.serviceName}`, status: estimate.statusName, isIndented: true });
    });

    return rows;
  });

export const ServiceStatusDetailTable = ({ rows, type }) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell sx={detailHeaderSx}>{type}</TableCell>
        <TableCell sx={detailHeaderSx}>Status</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {rows.map((row, index) =>
        row.isPlaceholder ? (
          <TableRow key={`${row.name}-${index}`}>
            <TableCell colSpan={2} sx={{ ...detailCellSx, paddingLeft: `${DETAIL_CELL_INDENT_X}px`, fontStyle: 'italic', color: '#868686' }}>
              {row.name}
            </TableCell>
          </TableRow>
        ) : (
          <TableRow key={`${row.name}-${index}`}>
            <TableCell sx={{ ...detailCellSx, paddingLeft: row.isIndented ? `${DETAIL_CELL_INDENT_X}px` : `${DETAIL_CELL_PADDING_X}px` }}>
              {row.name}
            </TableCell>
            <TableCell sx={detailCellSx}>{row.status}</TableCell>
          </TableRow>
        )
      )}
    </TableBody>
  </Table>
);

ServiceStatusDetailTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.string.isRequired
};

/* Renders the status chip, plus a hover popover of the per segment / per stay breakdown when there is more than one. */
export const ServiceStatusValue = ({ status, detailRows, type }) => (
  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px', marginLeft: '22px' }}>
    <Typography variant="body2" sx={{ backgroundColor: '#edf7ed', padding: '3px 6px', borderRadius: '4px', display: 'inline-block' }}>
      {status}
    </Typography>
    {detailRows && detailRows.length > 0 && (
      <Tooltip
        arrow
        placement="left-start"
        title={<ServiceStatusDetailTable rows={detailRows} type={type} />}
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: '#fff',
              border: '1px solid #e0e0e0',
              boxShadow: '0px 3px 6px rgba(0,0,0,0.16)',
              maxWidth: 'none',
              padding: 0,
              overflow: 'hidden'
            }
          },
          arrow: { sx: { color: '#fff', '&::before': { border: '1px solid #e0e0e0' } } }
        }}
      >
        <InfoOutlined sx={{ fontSize: '1rem', color: COLOR_PRIMARY.main, cursor: 'pointer' }} />
      </Tooltip>
    )}
  </Box>
);

ServiceStatusValue.propTypes = {
  status: PropTypes.string,
  detailRows: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.string.isRequired
};

const ServicesEditableCard = props => {
  const { status, servicesInfo, surveyInfo, updateFields, isLoading, updateStatusFields, hideEdit = false } = props; // webAccess accessible in props
  const classes = useStyles();

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  // const listingInfo = (homesaleService?.listings && homesaleService?.listings[0]) ? homesaleService?.listings[0] : null;

  const [editingModalOpen, setEditingModalOpen] = useState(false);
  const [viewSurveyModalOpen, setViewSurveyModalOpen] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [currentSurvey, setCurrentSurvey] = useState(surveyInfo && surveyInfo.length > 0 ? surveyInfo[0] : null);

  //const [fileTimelineModalOpen, setFileTimelineModalOpen] = useState(false);
  // const [selectedFileStatusId, setSelectedFileStatusId] = useState(status ?? AUTHORIZATION_FILE_STATUS_IDS.NONE);

  // keep it simple: whatever set you consider "valid" for the dropdown
  const fileStatusOptions = [
    { id: AUTHORIZATION_FILE_STATUS_IDS.PENDING, title: 'Pending' },
    { id: AUTHORIZATION_FILE_STATUS_IDS.ACTIVE, title: 'Active' },
    { id: AUTHORIZATION_FILE_STATUS_IDS.ON_ASSIGNMENT, title: 'On Assignment' },
    { id: AUTHORIZATION_FILE_STATUS_IDS.ON_HOLD, title: 'On Hold' },
    { id: AUTHORIZATION_FILE_STATUS_IDS.CANCELLED, title: 'Canceled' },
    { id: AUTHORIZATION_FILE_STATUS_IDS.CLOSED, title: 'Closed' },
    { id: AUTHORIZATION_FILE_STATUS_IDS.OPS_CLOSED, title: 'Ops Closed' }
  ];

  // useEffect(() => {
  //   setSelectedFileStatusId(status ?? AUTHORIZATION_FILE_STATUS_IDS.NONE);
  // }, [status]);

  const handleSaveEdits = async (
    temporaryLiving,
    homesale,
    global,
    homefindRenter,
    candidate,
    householdGoods,
    homefindBuyer,
    selectedFileStatusId
  ) => {
    if (!Object.keys(validationErrors).length) {
      // Send update call to parent to update and refresh values.
      if (updateFields) {
        const resp = await updateFields(temporaryLiving, homesale, global, homefindRenter, candidate, householdGoods, homefindBuyer);
        if (!resp) {
          showToast('Failed to update card data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return;
        } else {
          await updateStatusFields(selectedFileStatusId);
          setEditingModalOpen(false);
        }
      }
      setEditingModalOpen(false); //required to exit editing mode and close modal
    }
  };

  const calculateOverallScore = (responses) => {
    if (!responses || !responses.length) return '-';
    const totalScore = responses.reduce((acc, response) => acc + (response.score || 0), 0);
    return (totalScore / responses.length).toFixed(2);
  };

  const handleCancelEdits = () => {
    setValidationErrors({});
    setEditingModalOpen(false); //required to exit editing mode and close modal
  };

  const tempLivingActive =
    servicesInfo.temporaryLiving && (servicesInfo.temporaryLiving === 'Completed' || servicesInfo.temporaryLiving === 'Initiated');
  const destinationServicesBuyerActive =
    servicesInfo.homefindBuyer != null && servicesInfo.homefindBuyer !== 'Canceled' && servicesInfo.homefindBuyer !== 'On Hold';
  const destinationServicesRenterActive =
    servicesInfo.homefindRenter && servicesInfo.homefindRenter !== 'Canceled' && servicesInfo.homefindRenter !== 'On Hold';
  const candidateServicesActive =
    servicesInfo.candidate && (servicesInfo.candidate === 'Completed' || servicesInfo.candidate === 'Initiated');
  const householdGoodsActive =
    servicesInfo.householdGoods && (servicesInfo.householdGoods === 'Completed' || servicesInfo.householdGoods === 'Initiated');
  const globalActive = servicesInfo.global && servicesInfo.global !== 'Canceled' && servicesInfo.global !== 'On Hold';
  const homesaleActive = servicesInfo.homesale && (servicesInfo.homesale === 'Completed' || servicesInfo.homesale === 'Initiated');

  // The breakdown popover only appears once there is more than one segment / stay to break down.
  const hhgSegments = Array.isArray(servicesInfo.hhgSegments) ? servicesInfo.hhgSegments : null;
  const tempLivingStatuses = Array.isArray(servicesInfo.tempLivingStatuses) ? servicesInfo.tempLivingStatuses : null;

  const householdGoodsStatus = resolveGroupedServiceStatus(hhgSegments, servicesInfo.householdGoods);
  const temporaryLivingStatus = resolveGroupedServiceStatus(tempLivingStatuses, servicesInfo.temporaryLiving);

  const hhgDetailRows = hhgSegments && hhgSegments.length > 1 ? buildHhgDetailRows(hhgSegments) : null;
  const tempLivingDetailRows = tempLivingStatuses && tempLivingStatuses.length > 1 ? buildTempLivingDetailRows(tempLivingStatuses) : null;

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.card}>
        <CardContent sx={{ padding: '16px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <Typography variant="h6">Services</Typography>
            {!hideEdit && (
              <Fab color="primary" size="small" onClick={() => setEditingModalOpen(true)}>
                <FontAwesomeIcon size="1x" icon={['fas', 'pen']} color={theme.palette.common.white} />
              </Fab>
            )}
          </Box>
          <Grid container spacing={1}>
            {status && (
              <Grid item xs={6}>
                <Box
                  sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}
                // onClick={() => setFileTimelineModalOpen(true)}
                >
                  {status === AUTHORIZATION_FILE_STATUS_IDS.CLOSED && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {status === AUTHORIZATION_FILE_STATUS_IDS.ON_HOLD && <PauseCircle fontSize="small" color="secondary" />}
                  {status === AUTHORIZATION_FILE_STATUS_IDS.ON_ASSIGNMENT && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'stroopwafel']} color={COLOR_SECONDARY.main} />
                  )}
                  {status !== AUTHORIZATION_FILE_STATUS_IDS.ON_ASSIGNMENT &&
                    status !== AUTHORIZATION_FILE_STATUS_IDS.CLOSED &&
                    status !== AUTHORIZATION_FILE_STATUS_IDS.ON_HOLD && (
                      <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                    )}
                  <Typography variant="subtitle2">File Timeline</Typography>
                </Box>
                <Typography
                  variant="body2"
                  // onClick={() => setFileTimelineModalOpen(true)}
                  sx={{
                    backgroundColor: '#edf7ed',
                    padding: '3px 6px',
                    borderRadius: '4px',
                    display: 'inline-block',
                    marginLeft: '22px',
                    cursor: 'pointer',
                    userSelect: 'none'
                  }}
                >
                  {status ? status.title : 'N/a'}
                </Typography>
              </Grid>
            )}
            {servicesInfo.homesale != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {servicesInfo.homesale === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.homesale === 'Cancelled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.homesale === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {servicesInfo.homesale !== 'Cancelled' &&
                    servicesInfo.homesale !== 'Completed' &&
                    servicesInfo.homesale !== 'On Hold' && (
                      <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                    )}
                  <Typography variant="subtitle2" sx={{ a: { color: homesaleActive ? '#36939B' : '#868686' } }}>
                    {<Link to={`/authorizations/${servicesInfo.fileId}/homesale`}>Homesale</Link>}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ backgroundColor: '#edf7ed', padding: '3px 6px', borderRadius: '4px', display: 'inline-block', marginLeft: '22px' }}
                >
                  {servicesInfo.homesale}
                </Typography>
              </Grid>
            )}
            {servicesInfo.global != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {servicesInfo.global === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.global === 'Canceled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.global === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {servicesInfo.global !== 'Canceled' && servicesInfo.global !== 'Completed' && servicesInfo.global !== 'On Hold' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                  )}
                  <Typography variant="subtitle2" sx={{ a: { color: globalActive ? '#36939B' : '#868686' } }}>
                    {hideEdit ? 'Global' : <Link to={`/authorizations/${servicesInfo.fileId}/global`}>Global</Link>}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ backgroundColor: '#edf7ed', padding: '3px 6px', borderRadius: '4px', display: 'inline-block', marginLeft: '22px' }}
                >
                  {servicesInfo.global}
                </Typography>
              </Grid>
            )}
            {servicesInfo.homefindRenter != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {servicesInfo.homefindRenter === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.homefindRenter === 'Cancelled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.homefindRenter === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {servicesInfo.homefindRenter !== 'Cancelled' &&
                    servicesInfo.homefindRenter !== 'Completed' &&
                    servicesInfo.homefindRenter !== 'On Hold' && (
                      <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                    )}
                  <Typography variant="subtitle2" sx={{ a: { color: destinationServicesRenterActive ? '#36939B' : '#868686' } }}>
                    {<Link to={`/authorizations/${servicesInfo.fileId}/renterServices`}>Destination Services: Renter</Link>}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ backgroundColor: '#edf7ed', padding: '3px 6px', borderRadius: '4px', display: 'inline-block', marginLeft: '22px' }}
                >
                  {servicesInfo.homefindRenter.length > 0 ? servicesInfo.homefindRenter : 'Initiated'}
                </Typography>
              </Grid>
            )}
            {servicesInfo.homefindBuyer != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {servicesInfo.homefindBuyer === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.homefindBuyer === 'Cancelled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.homefindBuyer === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {servicesInfo.homefindBuyer !== 'Cancelled' &&
                    servicesInfo.homefindBuyer !== 'Completed' &&
                    servicesInfo.homefindBuyer !== 'On Hold' && (
                      <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                    )}
                  <Typography variant="subtitle2" sx={{ a: { color: destinationServicesBuyerActive ? '#36939B' : '#868686' } }}>
                    {<Link to={`/authorizations/${servicesInfo.fileId}/buyerServices`}>Destination Services: Buyer</Link>}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ backgroundColor: '#edf7ed', padding: '3px 6px', borderRadius: '4px', display: 'inline-block', marginLeft: '22px' }}
                >
                  {servicesInfo.homefindBuyer.length > 0 ? servicesInfo.homefindBuyer : 'Initiated'}
                </Typography>
              </Grid>
            )}
            {servicesInfo.candidate != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {servicesInfo.candidate === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.candidate === 'Cancelled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {servicesInfo.candidate === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {servicesInfo.candidate !== 'Cancelled' &&
                    servicesInfo.candidate !== 'Completed' &&
                    servicesInfo.candidate !== 'On Hold' && (
                      <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                    )}
                  <Typography variant="subtitle2" sx={{ a: { color: candidateServicesActive ? '#36939B' : '#868686' } }}>
                    {<Link to={`/authorizations/${servicesInfo.fileId}/candidateServices`}>Candidate/Intern Services</Link>}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ backgroundColor: '#edf7ed', padding: '3px 6px', borderRadius: '4px', display: 'inline-block', marginLeft: '22px' }}
                >
                  {servicesInfo.candidate}
                </Typography>
              </Grid>
            )}
            {servicesInfo.temporaryLiving != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {temporaryLivingStatus === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {temporaryLivingStatus === 'Cancelled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {temporaryLivingStatus === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {temporaryLivingStatus !== 'Cancelled' && temporaryLivingStatus !== 'Completed' && temporaryLivingStatus !== 'On Hold' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                  )}
                  <Typography variant="subtitle2" sx={{ a: { color: tempLivingActive ? '#36939B' : '#868686' } }}>
                    {<Link to={`/authorizations/${servicesInfo.fileId}/tempLiving`}>Temporary Living</Link>}
                  </Typography>
                </Box>
                <ServiceStatusValue status={temporaryLivingStatus} detailRows={tempLivingDetailRows} type="Assignment" />
              </Grid>
            )}
            {servicesInfo.householdGoods != null && (
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', paddingBottom: '4px' }}>
                  {householdGoodsStatus === 'Completed' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'check-circle']} color={COLOR_SECONDARY.main} />
                  )}
                  {householdGoodsStatus === 'Cancelled' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-xmark']} color={COLOR_SECONDARY.main} />
                  )}
                  {householdGoodsStatus === 'On Hold' && <PauseCircle fontSize="small" color="secondary" />}
                  {householdGoodsStatus !== 'Cancelled' && householdGoodsStatus !== 'Completed' && householdGoodsStatus !== 'On Hold' && (
                    <FontAwesomeIcon size="lg" icon={['fas', 'circle-arrow-right']} color={COLOR_SECONDARY.main} />
                  )}
                  <Typography variant="subtitle2" sx={{ a: { color: householdGoodsActive ? '#36939B' : '#868686' } }}>
                    {<Link to={`/authorizations/${servicesInfo.fileId}/hhg`}>Household Goods</Link>}
                  </Typography>
                </Box>
                <ServiceStatusValue status={householdGoodsStatus} detailRows={hhgDetailRows} type="Segment" />
              </Grid>
            )}
          </Grid>
          {surveyInfo && surveyInfo.length > 1 && (
            <Box sx={{ paddingBottom: '8px' }}>
              <FormControl variant="standard" sx={{ minWidth: 200 }}>
                <InputLabel id="survey-select-label">Survey</InputLabel>
                <Select
                  labelId="survey-select-label"
                  value={currentSurvey?.survey?.transfereeSurveyId ?? ''}
                  onChange={e => setCurrentSurvey(surveyInfo.find(s => s.survey.transfereeSurveyId === e.target.value))}
                >
                  {surveyInfo.map(s => (
                    <MenuItem key={s.survey.transfereeSurveyId} value={s.survey.transfereeSurveyId}>
                      Created: {formatDateForInput(s.survey.createdDate)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
          {currentSurvey && (
            <Box>
            <Box sx={{ width: '100%' }}>
              <hr />
            </Box>
            <Grid container spacing={1} columns={{ xs: 2, sm: 2, md: 2, xl: 2 }}>
              <Grid item xs={1} sm={1} md={1} xl={1}>
                <Box sx={{ backgroundColor: 'transparent', borderRadius: '4px', padding: '3px 4px', display: 'inline-block' }}>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Survey Sent
                    </Typography>
                  </div>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {currentSurvey.survey.createdDate ? formatDateForInput(currentSurvey.survey.createdDate) : '-'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={1} sm={1} md={1} xl={1}>
                <Box sx={{ backgroundColor: 'transparent', borderRadius: '4px', padding: '3px 4px', display: 'inline-block' }}>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Survey Recieved
                    </Typography>
                  </div>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {currentSurvey.survey.completedDate ? formatDateForInput(currentSurvey.survey.completedDate) : '-'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={1} sm={1} md={1} xl={1}>
                <Box sx={{ backgroundColor: 'transparent', borderRadius: '4px', padding: '3px 4px', display: 'inline-block' }}>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Overall Score
                    </Typography>
                  </div>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {currentSurvey.survey.completedDate ? calculateOverallScore(currentSurvey.responses) : '-'}
                    </Typography>
                  </div>
                </Box>
              </Grid>
              <Grid item xs={1} sm={1} md={1} xl={1}>
                <Box sx={{ backgroundColor: 'transparent', borderRadius: '4px', padding: '3px 4px', display: 'inline-block' }}>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      <MuiLink component="button" type="button" underline="hover" onClick={() => setViewSurveyModalOpen(true)}>
                        See Full Results
                      </MuiLink>
                    </Typography>
                  </div>
                </Box>
              </Grid>
            </Grid>
            </Box>
          )}
        </CardContent>
      </Card>
      {/* <Dialog open={fileTimelineModalOpen} onClose={() => setFileTimelineModalOpen(false)} fullWidth maxWidth="sm">
        <Box sx={{ padding: '20px 24px 0px 24px' }}>
          <Typography variant="h6">Update File Status</Typography>
        </Box>

        <Box sx={{ padding: '16px 24px 8px 24px' }}>
          <FormControl fullWidth variant="standard">
            <InputLabel id="file-status-label">File Status</InputLabel>
            <Select labelId="file-status-label" value={selectedFileStatusId} onChange={e => setSelectedFileStatusId(e.target.value)}>
              {fileStatusOptions.map(opt => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <DialogActions sx={{ padding: '12px 24px 16px 24px' }}>
          <Button onClick={() => setFileTimelineModalOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              updateStatusFields(selectedFileStatusId);
              setFileTimelineModalOpen(false);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog> */}
      {editingModalOpen && (
        <EditCardModal
          servicesInfo={servicesInfo}
          status={status}
          fileStatusOptions={fileStatusOptions}
          classes={classes}
          open={editingModalOpen}
          isLoading={isLoading}
          onClose={handleCancelEdits}
          onSubmit={handleSaveEdits}
        />
      )}
      {viewSurveyModalOpen && (
        <ViewSurveyModal
          classes={classes}
          open={viewSurveyModalOpen}
          surveyInfo={currentSurvey}
          isLoading={isLoading}
          onClose={() => setViewSurveyModalOpen(false)}
        />
      )}
    </ThemeProvider>
  );
};
ServicesEditableCard.propTypes = {
  updateFields: PropTypes.func.isRequired,
  showToast: PropTypes.func.isRequired
};
export default connect(null, { showToast })(ServicesEditableCard);

export const ViewSurveyModal = ({ open, classes, surveyInfo, onClose, isLoading }) => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const StyledRating = styled(Rating)(({ theme }) => ({
    '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
      color: theme.palette.action.disabled
    }
  }));

  const customIcons = {
    1: { icon: <SentimentVeryDissatisfiedIcon color="error" />, label: 'Very Dissatisfied' },
    2: { icon: <SentimentDissatisfiedIcon color="error" />, label: 'Dissatisfied' },
    3: { icon: <SentimentSatisfiedIcon color="warning" />, label: 'Neutral' },
    4: { icon: <SentimentSatisfiedAltIcon color="warning" />, label: 'Mostly Satisfied' },
    5: { icon: <TagFacesIcon color="success" />, label: 'Satisfied' },
    6: { icon: <SentimentVerySatisfiedIcon color="success" />, label: 'Very Satisfied' }
  };

  const IconContainer = ({ value, ...other }) => <span {...other}>{customIcons[value]?.icon}</span>;

  const responses = surveyInfo?.responses || [];

  const renderQuestion = response => (
    <Grid item xs={1} sm={1} md={1} xl={1} key={response.surveyQuestionId}>
      <div className={classes.mb2}>
        <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 'bold', fontSize: '1rem', paddingBottom: '6px' }}>
          {surveyInfo.questions?.find(q => q.transfereeSurveyQuestionId === response.transfereeSurveyQuestionId)?.questionText}
        </Typography>
      </div>
      <StyledRating
        name={`survey-question-${response.surveyQuestionId}`}
        value={response.score || 0}
        readOnly
        IconContainerComponent={IconContainer}
        getLabelText={value => customIcons[value]?.label}
        highlightSelectedOnly
        max={6}
      />
      <div className={classes.mb2}>
        <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 'bold', fontSize: '1rem', paddingTop: '6px' }}>
          Comments
        </Typography>
      </div>
      <div className={classes.mb2}>
        <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 400, fontSize: '1rem' }}>
          {response.comment ? response.comment : <div>&mdash;</div>}
        </Typography>
      </div>
    </Grid>
  );

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
        <Box sx={{ padding: '20px 24px 0px 24px' }}>
          <Typography variant="h5">Survey Results</Typography>
        </Box>
        <Box sx={{ padding: '16px 24px' }}>
          <Grid container spacing={1} columns={{ xs: 2, sm: 2, md: 2, xl: 2 }}>
            <Grid item xs={1} sm={1} md={1} xl={1}>
              <div className={classes.mb2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Survey Sent
                </Typography>
              </div>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                {surveyInfo?.survey?.createdDate ? formatDateForInput(surveyInfo.survey.createdDate) : '-'}
              </Typography>
            </Grid>
            <Grid item xs={1} sm={1} md={1} xl={1}>
              <div className={classes.mb2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Survey Recieved
                </Typography>
              </div>
              <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                {surveyInfo?.survey?.completedDate ? formatDateForInput(surveyInfo.survey.completedDate) : '-'}
              </Typography>
            </Grid>
          </Grid>
          <Box sx={{ width: '100%', paddingTop: '16px' }}>
            <hr />
          </Box>
          {responses.length === 0 ? (
            <Typography variant="body2" sx={{ color: '#43423a', paddingTop: '16px' }}>
              No question responses recorded for this survey.
            </Typography>
          ) : (
            <Grid container spacing={1} columns={{ xs: 2, sm: 2, md: 2, xl: 2 }} sx={{ paddingTop: '16px' }}>
              {responses.map(renderQuestion)}
            </Grid>
          )}
        </Box>
        {isLoading ? (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Spinner />
          </DialogActions>
        ) : (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        )}
      </Dialog>
    </ThemeProvider>
  );
};

ViewSurveyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  surveyInfo: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

export const EditCardModal = ({ open, classes, servicesInfo, status, fileStatusOptions, onClose, onSubmit, isLoading }) => {
  const serviceFieldConfig = [
    { key: 'homesale', label: 'Homesale' },
    { key: 'global', label: 'Global' },
    { key: 'homefindRenter', label: 'Destination Services: Renter' },
    { key: 'homefindBuyer', label: 'Destination Services: Buyer' },
    { key: 'candidate', label: 'Candidate/Intern Services' },
    { key: 'temporaryLiving', label: 'Temporary Living' },
    { key: 'householdGoods', label: 'Household Goods' }
  ];

  const [temporaryLiving, setTemporaryLiving] = useState(servicesInfo.temporaryLiving !== null);
  const [homesale, setHomesale] = useState(servicesInfo.homesale !== null);
  const [global, setGlobal] = useState(servicesInfo.global !== null);
  const [homefindRenter, setHomefindRenter] = useState(servicesInfo.homefindRenter !== null);
  const [homefindBuyer, setHomefindBuyer] = useState(servicesInfo.homefindBuyer !== null);
  const [candidate, setCandidate] = useState(servicesInfo.candidate !== null);
  const [householdGoods, setHouseholdGoods] = useState(servicesInfo.householdGoods !== null);
  const [selectedFileStatusId, setSelectedFileStatusId] = useState(status ? status.id : AUTHORIZATION_FILE_STATUS_IDS.NONE);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const originalServiceState = {
    homesale: servicesInfo.homesale !== null,
    global: servicesInfo.global !== null,
    homefindRenter: servicesInfo.homefindRenter !== null,
    homefindBuyer: servicesInfo.homefindBuyer !== null,
    candidate: servicesInfo.candidate !== null,
    temporaryLiving: servicesInfo.temporaryLiving !== null,
    householdGoods: servicesInfo.householdGoods !== null
  };

  const editedServiceState = {
    homesale,
    global,
    homefindRenter,
    homefindBuyer,
    candidate,
    temporaryLiving,
    householdGoods
  };

  const serviceChanges = serviceFieldConfig
    .filter(service => originalServiceState[service.key] !== editedServiceState[service.key])
    .map(service => ({
      ...service,
      action: editedServiceState[service.key] ? 'Enable' : 'Disable'
    }));

  const handleSubmit = e => {
    e.preventDefault();
    setConfirmationModalOpen(true);
  };

  const handleConfirmSave = async () => {
    setConfirmationModalOpen(false);
    // Convert booleans back to strings for submission
    await onSubmit(
      temporaryLiving ? 'Initiated' : 'Not Initiated',
      homesale ? 'Initiated' : 'Not Initiated',
      global ? 'Initiated' : 'Not Initiated',
      homefindRenter ? 'Initiated' : 'Not Initiated',
      candidate ? 'Initiated' : 'Not Initiated',
      householdGoods ? 'Initiated' : 'Not Initiated',
      homefindBuyer ? 'Initiated' : 'Not Initiated',
      selectedFileStatusId
    );
  };

  const handleCancel = e => {
    e.preventDefault();
    onClose();
  };

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'lg'}>
      <form onSubmit={handleSubmit} fullScreen>
        <div className="row justify-space-between align-center">
          <div className={classes.dialogIconRow}>
            <Typography variant="h5">Services</Typography>
          </div>
        </div>
        <div className={classes.dialogContentContainer}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
              gap: '1.5rem'
            }}
          >
            <Grid container spacing={{ xs: 2, md: 3 }} sx={{ padding: '30px', paddingTop: '0px' }}>
              <Grid item xs={3} md={3}>
                <FormControl fullWidth variant="standard" sx={{ marginTop: '10px' }}>
                  <InputLabel id="file-status-label">File Status</InputLabel>
                  <Select
                    labelId="file-status-label"
                    value={selectedFileStatusId.toUpperCase()}
                    onChange={e => setSelectedFileStatusId(e.target.value)}
                  >
                    {fileStatusOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={9}></Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'homesale'}
                    name={'homesale'}
                    label={'Homesale'}
                    labelPlacement="start"
                    control={<Checkbox checked={homesale} onChange={e => setHomesale(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'global'}
                    name={'global'}
                    label={'Global'}
                    labelPlacement="start"
                    control={<Checkbox checked={global} onChange={e => setGlobal(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'homefindRenter'}
                    name={'homefindRenter'}
                    label={'Destination Services: Renter'}
                    labelPlacement="start"
                    control={<Checkbox checked={homefindRenter} onChange={e => setHomefindRenter(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'homefindBuyer'}
                    name={'homefindBuyer'}
                    label={'Destination Services: Buyer'}
                    labelPlacement="start"
                    control={<Checkbox checked={homefindBuyer} onChange={e => setHomefindBuyer(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'candidate'}
                    name={'candidate'}
                    label={'Candidate/Intern Services'}
                    labelPlacement="start"
                    control={<Checkbox checked={candidate} onChange={e => setCandidate(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'temporaryLiving'}
                    name={'temporaryLiving'}
                    label={'Temporary Living'}
                    labelPlacement="start"
                    control={<Checkbox checked={temporaryLiving} onChange={e => setTemporaryLiving(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'householdGoods'}
                    name={'householdGoods'}
                    label={'Household Goods'}
                    labelPlacement="start"
                    control={<Checkbox checked={householdGoods} onChange={e => setHouseholdGoods(e.target.checked)} />}
                    variant="standard"
                    margin="dense"
                    sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Stack>
        </div>
        {isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Spinner />
          </DialogActions>
        )}
        {!isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button color="primary" type="submit" variant="contained">
              Save
            </Button>
          </DialogActions>
        )}
      </form>

      <Dialog open={confirmationModalOpen} onClose={() => setConfirmationModalOpen(false)} fullWidth maxWidth="sm">
        <Box sx={{ padding: '20px 24px 0px 24px' }}>
          <Typography variant="h6">Confirm Service Changes</Typography>
          <Typography variant="body2" sx={{ marginTop: '10px', color: '#43423a' }}>
            Confirm to save the following service updates, or Cancel to return to editing.
          </Typography>
        </Box>

        <Box sx={{ padding: '12px 24px 8px 24px' }}>
          {serviceChanges.length === 0 ? (
            <Typography variant="body2" sx={{ color: '#43423a' }}>
              No service enable/disable changes were detected.
            </Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Service</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Pending Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serviceChanges.map(change => (
                  <TableRow key={change.key}>
                    <TableCell>{change.label}</TableCell>
                    <TableCell>{change.action}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Box>

        <DialogActions sx={{ padding: '12px 24px 16px 24px' }}>
          <Button onClick={() => setConfirmationModalOpen(false)}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleConfirmSave}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};
